// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-list-container .fi-content {
  padding-top: 20px;
  padding-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./Source/app/task/task-list.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;EACA,oBAAA;AAAR","sourcesContent":[".fi-task-list-container {\r\n    .fi-content {\r\n        padding-top: 20px;\r\n        padding-bottom: 12px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
